import { createSelector } from 'reselect'

export const selectOrder = state => state.order

export const selectListOrders = createSelector(
	[selectOrder],
	order => order.data
)

export const selectTotalOrders = createSelector(
	[selectOrder],
	order => order.total
)

export const selectCurrentPageListOrders = createSelector(
	[selectOrder],
	order => order.currentPage
)
